import { useState } from "react";
import DatePicker from "react-datepicker";

import "./AppDateRangePicker.scss";

const AppDateRangePicker = ({ placeholder = "Select a date range", isClearable = false, onChange }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  
    const bothSet = start && end;
    const bothCleared = !start && !end;
  
    if ((bothSet || bothCleared) && typeof onChange === "function") {
      onChange({ start, end });
    }
  };

  return (
    <DatePicker
      calendarClassName="custom-datepicker-calendar"
      wrapperClassName="custom-datepicker-wrapper"
      className="form-control custom-datepicker-input"
      showIcon
      selected={startDate}
      onChange={handleDateRangeChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      isClearable={isClearable}
      placeholderText={placeholder}
    />
  )
}

export default AppDateRangePicker;